export default function ApiLoading({message}){
    return <>
        <div className="p-2 text-center">
            <p className="text-success fw-bold">{message}</p>
            <img src="/image/loading.gif" alt={`loadinggif`} className="img-fluid" width="190" height="250" />
        </div>
    </>;
}